/* eslint-disable */
import type { RequestContext } from "../RequestContextProto.pb";
import type { ResponseContext } from "../ResponseContextProto.pb";

/** The request to get the current ScenarioPlan. Use this request when resuming onboarding. */
export interface GetScenarioPlanRequest {
  request_context?: RequestContext;
}

export interface GetScenarioPlanResponse {
  response_context?: ResponseContext;
  status?: GetScenarioPlanResponseStatus;
}

export enum GetScenarioPlanResponseStatus {
  INVALID = "INVALID",
  /** SUCCESS - Tags are out of order. Next tag = 3. */
  SUCCESS = "SUCCESS",
}

/**
 * Resumes an existing a flow based on the Flow Token in the request headers,
 * or creates a new flow based on the Client Scenario in the request headers.
 *
 * Requires a flow token in `Cash-Flow-Token` header.
 * Requires a valid client scenario in `Cash-Client-Scenario` header.
 * Cannot take flow parameters.
 * Idempotent.
 *
 * See also https://cash-dev-guide.squarecloudservices.com/product_velocity/plasma/overview/
 */
export interface CompleteScenarioRequest {
  request_context?: RequestContext;
  /** Only used by Franklin (not Plasma). */
  payment_tokens?: string[];
  /** Only used by Franklin (not Plasma). */
  transfer_token?: string;
  /** Backup tag associated with a customer's iCloud/Google account */
  backup_tag?: string;
}

/**
 * Contains the next blocker(s) in the new or existing flow, stored in
 * response_context.scenario_plan.blocker_descriptors
 */
export interface CompleteScenarioResponse {
  response_context?: ResponseContext;
  /** In Plasma this will always be SUCCESS. */
  status?: CompleteScenarioResponseStatus;
}

export enum CompleteScenarioResponseStatus {
  INVALID = "INVALID",
  SUCCESS = "SUCCESS",
}
